import type { ReactNode } from 'react'
import { Popconfirm } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

export interface DeleteConfirmProps {
  onConfirm?: (...args: any[]) => void
  onCancel?: (...args: any[]) => void
  onVisibleChange?: (visible: boolean) => void
  icon?: ReactNode
  title?: string
  customTitle?: string
  target?: string
  okText?: string
  cancelText?: string
  placement?:
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom'
  visible?: boolean
  bgcolor?: string
  children?: ReactNode
}

export function DeleteConfirm({
  onConfirm,
  onCancel,
  onVisibleChange,
  icon,
  title: titleProp,
  customTitle,
  target,
  okText,
  cancelText,
  placement = 'top',
  visible,
  bgcolor,
  children,
}: DeleteConfirmProps) {
  const { t } = useTranslation()

  const defaultIcon = (
    <QuestionCircleOutlined style={{ color: 'red' }} />
  )

  const title = customTitle ? (
    <span>
      {customTitle}
      <span className="text-red-500">{` ${target || ''}`}</span>
    </span>
  ) : titleProp ? (
    <span>
      <span className="text-red-500">{titleProp}</span>
    </span>
  ) : (
    <span>{t('are_you_sure_to_delete')}</span>
  )

  return (
    <Popconfirm
      onConfirm={onConfirm}
      onCancel={onCancel}
      onOpenChange={onVisibleChange}
      icon={icon || defaultIcon}
      title={title}
      okText={okText || t('yes')}
      cancelText={cancelText || t('no')}
      placement={placement}
      open={visible}
      style={{ background: bgcolor || 'transparent' }}
    >
      {children}
    </Popconfirm>
  )
}
